import { IconButton, Link, Menu, Typography } from "@material-ui/core";
import { useEffect, useRef, useState } from "react";
import { isMobile } from "react-device-detect";
import ic_bellOn from "../../../assets/ic_bellOn.svg";
import ic_bellOff from "../../../assets/ic_bellOff.svg";
import * as home from "../../../logics/shop/home";
import { useSelector } from "react-redux";
import { RootState } from "redux/store";

type NotificationModalProps = {
  dataList?: NotificationItem[];
};

type NotificationItem = {
  label: string;
  id: string;
};

const NotificationModal = ({ dataList = [] }: NotificationModalProps) => {
  const ref = useRef(null);
  const { shop } = useSelector((state: RootState) => state.auth);
  const [isOpen, setIsOpen] = useState(false);
  const [noticeCnt, setNoticeCnt] = useState(dataList.length);

  const prefix: string = "/board/notice";

  useEffect(() => {
    getNewList(shop);
  }, [shop]);
  const getNewList = async (shop: any) => {
    let res: any = [];
    if (shop != null && shop.PLUG_IN_NB) {
      try {
        res = await home.getNewNoticeList(
          String(shop.COMPANY_ID),
          String(shop.SHOP_ID)
        );
        if (res == null || res.length == 0) {
          return [];
        }

        setNoticeCnt(res.length);
      } catch (error) {
        console.log("getNewList error: ", error);
      }
    }

    return res;
  };

  return (
    <>
      {noticeCnt && (
        <IconButton
          ref={ref}
          onClick={() => setIsOpen(true)}
          style={
            isMobile
              ? {
                  border: "1px solid rgba(0, 0, 0, 0.1)",
                  borderRadius: 8,
                  padding: 0,
                  paddingLeft: 6,
                  paddingRight: 6,
                }
              : {
                  border: "1px solid rgba(0, 0, 0, 0.1)",
                  borderRadius: 8,
                  margin: 10,
                  paddingRight: 10,
                  paddingLeft: 10,
                }
          }
        >
          <img
            src={noticeCnt ? ic_bellOn : ic_bellOff}
            width={isMobile ? "15" : "20"}
            height="40"
            alt="img"
          />
        </IconButton>
      )}
      <Menu
        open={isOpen}
        anchorEl={ref.current}
        onClose={() => setIsOpen(false)}
        PaperProps={{
          sx: { maxWidth: 500, minWidth: 40 },
        }}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        transformOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <div style={{ padding: 10, paddingLeft: 20, paddingRight: 20 }}>
          {/* <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              // paddingBottom: 15,
            }}
          > */}
          {noticeCnt ? (
            // dataList.map((item: any, ind: any) => {
            //   return (
            //     <div key={item.id}>
            //       <Link
            //         href={prefix+item.id}
            //         variant="body2"
            //         underline="hover"
            //         key={item.id}
            //       >
            //         {item.label}
            //       </Link>
            //     </div>
            //   );
            // })
            <>
              <Typography variant="body2" component={"span"}>
                {"확인하지 않은 글이 "}
              </Typography>
              <Link
                href={prefix}
                variant="body2"
                underline="always"
                sx={{
                  "&:hover": {
                    cursor: "pointer",
                  },
                  fontWeight: "600",
                }}
              >
                {noticeCnt}
              </Link>
              <Typography variant="body2" component={"span"}>
                {"개 있습니다."}
              </Typography>
            </>
          ) : (
            <Typography variant="body2">{"알림이 없습니다."}</Typography>
          )}
          {/* </div> */}
        </div>
      </Menu>
    </>
  );
};

export default NotificationModal;
